import React from 'react';
import { useQuery } from '@apollo/client';
import styles from './styles.module.scss';
import DealFieldItem from './components/DealFieldItem';
import {
  GET_DEAL_FIELD_GROUPS,
  GET_TEAM_CONTACTS_FOR_BINDING,
} from '../../../api/placeholders/queries';

interface DealFieldsListProps {
  documentId: string;
  dealId: string;
  teamId: string;
  isReadOnly?: boolean;
  canLinkContacts?: boolean;
  onShowUpgradeModal?: () => void;
}

const DealFieldsList: React.FC<DealFieldsListProps> = ({ documentId, dealId, teamId, isReadOnly = false, canLinkContacts = true, onShowUpgradeModal }) => {
  const {
    data: dealFieldsData,
    loading,
    refetch: refetchDealFields,
  } = useQuery(GET_DEAL_FIELD_GROUPS, {
    variables: { dealId },
    skip: !dealId,
  });

  const { data: contactsData, refetch: refetchContacts } = useQuery(GET_TEAM_CONTACTS_FOR_BINDING, {
    variables: { teamId, search: '' },
    skip: !teamId,
  });

  const dealFieldGroups = dealFieldsData?.dealFieldGroups || [];
  const contacts = contactsData?.teamContacts || [];

  const handleRefetch = () => {
    refetchDealFields();
    refetchContacts();
  };

  if (loading) {
    return (
      <div className={styles.loading}>
        <div className={styles.spinner} />
      </div>
    );
  }

  if (dealFieldGroups.length === 0) {
    return (
      <div className={styles.emptyState}>
        <p>No deal-level fields yet</p>
        <p className={styles.fieldsSubtitle}>Link placeholders to create deal-level fields that sync across documents</p>
      </div>
    );
  }

  return (
    <div className={styles.fieldsList}>
      {dealFieldGroups.map((group: any) => (
        <DealFieldItem
          key={group.id}
          fieldGroup={group}
          contacts={contacts}
          documentId={documentId}
          dealId={dealId}
          teamId={teamId}
          isReadOnly={isReadOnly}
          canLinkContacts={canLinkContacts}
          onShowUpgradeModal={onShowUpgradeModal}
          onUpdate={handleRefetch}
        />
      ))}
    </div>
  );
};

export default DealFieldsList;
